<div class="filter_list grid">
    <label class="inp_group">
        <div class="lbl">Заказ</div>
        <input type="text" name="order" class="inp" placeholder="Заказ" [(ngModel)]="orderFilter.id">
    </label>
    <label class="inp_group">
        <div class="lbl">Клиент</div>
        <input type="text" name="customer" class="inp" placeholder="Клиент" [(ngModel)]="orderFilter.customerId">
    </label>
    <label class="inp_group">
        <div class="lbl">Сумма ($)</div>
        <mat-slider class="slider_input" [min]="0" [max]="2050" [step]="50" discrete>
            <input [(ngModel)]="orderFilter.totalFrom" matSliderStartThumb>
            <input [(ngModel)]="orderFilter.totalTo" matSliderEndThumb>
        </mat-slider>
    </label>
    <label class="inp_group">
        <div class="lbl">Пользователи</div>
        <select class="inp" name="users" (ngModelChange)="onSelectChange($event, 'users')" [(ngModel)]="selectedUsers">
            <option [ngValue]="null">Все</option>
            <option *ngFor="let user of optionsUsers" [value]="user.id">{{user.name}}</option>
        </select>
    </label>
    <label class="inp_group">
        <div class="lbl">Дата создания</div>
        <input [(ngModel)]="dateRange" [locale]="dateLocaleService.locale"  type="text" name="date" ngxDaterangepickerMd class="inp" placeholder="2024-12-31 - 2025-12-31"
            (change)="onDateChange($event)">
    </label>
</div>